module.exports = __webpack_public_path__ + "img/mall_04.30899c49.png";